import { MandateURL } from "@adapters/infrastructures/urlConfig/Mandate/MandateUrl";
import { emandateUrl, mandateSwitch } from "./dummyResponse";
class MandateFlowRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async uploadMandateImg(req) {
        const url = new URL(MandateURL.uploadMandateImage);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async createBankMandate(req) {
        const url = new URL(MandateURL.mfMandate(await this.accountDetails.getUserID()));
        const mandate = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return mandate.data;
    }
    async getMfBankDetails() {
        const url = new URL(MandateURL.mfBankDetails(await this.accountDetails.getUserID()));
        // return mfBankdetails;
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async getMfMandate() {
        const url = new URL(MandateURL.mfMandate(await this.accountDetails.getUserID()));
        // return mandate;
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async downloadMandate(req) {
        const url = new URL(MandateURL.downloadMandate);
        url.searchParams.append("mandateId", req.mandateId);
        url.searchParams.append("clientId", req.clientId);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async mandateSwitch() {
        // const url = new URL(MandateURL.mandateSwitch);
        // const switchData =  await this.http.makeApiCall<IMandateSwitchParams>({
        //   method: "GET",
        //   url: url.toString(),
        // });
        const switchData = mandateSwitch;
        return switchData.data;
    }
    async getEmandateUrl(req) {
        const url = new URL(MandateURL.emandateUrl(await this.accountDetails.getUserID()));
        url.searchParams.append("mandateId", req.mandateId);
        // const response = await this.http.makeApiCall<IEmandateUrlParams>({
        //   method: "GET",
        //   url: url.toString(),
        // });
        const response = emandateUrl;
        return response.data;
    }
}
export default MandateFlowRepository;
